export const GET_BLACKLIST_ORIGINATORS_REQUEST = 'GET_BLACKLIST_ORIGINATORS_REQUEST';
export const GET_BLACKLIST_ORIGINATORS_SUCCESS = 'GET_BLACKLIST_ORIGINATORS_SUCCESS';
export const GET_BLACKLIST_ORIGINATORS_FAILURE = 'GET_BLACKLIST_ORIGINATORS_FAILURE';

export const CREATE_BLACKLIST_ORIGINATOR_REQUEST = 'CREATE_BLACKLIST_ORIGINATOR_REQUEST';
export const CREATE_BLACKLIST_ORIGINATOR_SUCCESS = 'CREATE_BLACKLIST_ORIGINATOR_SUCCESS';
export const CREATE_BLACKLIST_ORIGINATOR_FAILURE = 'CREATE_BLACKLIST_ORIGINATOR_FAILURE';

export const UPDATE_BLACKLIST_ORIGINATOR_REQUEST = 'UPDATE_BLACKLIST_ORIGINATOR_REQUEST';
export const UPDATE_BLACKLIST_ORIGINATOR_SUCCESS = 'UPDATE_BLACKLIST_ORIGINATOR_SUCCESS';
export const UPDATE_BLACKLIST_ORIGINATOR_FAILURE = 'UPDATE_BLACKLIST_ORIGINATOR_FAILURE';

export const DELETE_BLACKLIST_ORIGINATOR_REQUEST = 'DELETE_BLACKLIST_ORIGINATOR_REQUEST';
export const DELETE_BLACKLIST_ORIGINATOR_SUCCESS = 'DELETE_BLACKLIST_ORIGINATOR_SUCCESS';
export const DELETE_BLACKLIST_ORIGINATOR_FAILURE = 'DELETE_BLACKLIST_ORIGINATOR_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/blacklist/mutation-types.js